window.openModal = function (path) {
    const modalContent = $('.modal-content');
    const loadingText = modalContent.data('loading-text');

    let loadingTimeout;
    const loadingDelay = 700; // 700ms delay before showing the loading spinner and text

    // Set a timeout to show the loading spinner and text after the delay
    loadingTimeout = setTimeout(function() {
        modalContent.html(`<div class="loading-overlay"><div class="spinner-border text-active" role="status"></div><p class="mt-3">${loadingText}</p></div>`);
        $('#modal').modal({
            show: true
        });
    }, loadingDelay);

    // Load the content and remove the loading spinner and text when it's loaded
    modalContent.load(window.getLocation(path), function () {
        clearTimeout(loadingTimeout); // Clear the loading timeout
        $('#modal').modal({
            show: true
        }); // Show the modal just in case the loading didn't show it before
    });
}

window.downloadFile = function (url, filename) {
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', url);
    linkElement.setAttribute('download', filename);
    linkElement.target = '_blank';

    const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false
    });
    linkElement.dispatchEvent(clickEvent);
}

window.scrollToTop = function () {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

window.scrollToElement = function (id) {
    const element = $('#' + id);
    window.scrollTo({
        top: element.offset().top - 100,
        behavior: 'smooth'
    });
}

window.getLocation = function (path) {
    return data.url + '/' + path + '?slug=' + data.slug;
}
